<script setup lang="ts">
import Translator from "@/plugins/Translator";
import {useThemeStore} from "@/stores/Theme";
import {useLanguageStore} from "@/stores/Language";
import {IonApp, IonRouterOutlet, IonSpinner} from "@ionic/vue";
import {onBeforeMount} from "vue";
import {useAuthStore} from "@/stores/Auth";
import ReloadPrompt from "@/ReloadPrompt.vue";
import {useCacheStore} from "@/stores/Cache";
import {useReportCacheStore} from "@/stores/ReportCache";

onBeforeMount(async () => {
  /*----- init auth store -----*/
  const authStore = useAuthStore();
  await authStore.init();

  /*----- init theme store -----*/
  const themeStore = useThemeStore();
  await themeStore.init();

  /*----- init language store -----*/
  const languageStore = useLanguageStore();
  await languageStore.init();

  /*----- init translator -----*/
  const translator = Translator.getInstance();
  translator.setLanguage(await languageStore.getLanguageFromStorage());

  /*----- init cache store -----*/
  const cacheStore = useCacheStore();
  await cacheStore.init();

  /*----- init report draft cache store -----*/
  const reportCacheStore = useReportCacheStore();
  await reportCacheStore.init();


  /*	if (window.Cypress) {
    console.log("window cypress loaded");
    window.stores = { authStore, themeStore, languageStore };
    window.translator = translator;
    console.log("window stores", window.stores);
  }*/
});

const themeStore = useThemeStore();
</script>

<template>
  <ion-app>
    <suspense>
      <template #default>
        <div :class="themeStore.theme">
          <ion-router-outlet  />
        </div>
      </template>
      <template #fallback>
        <div class="uk-position-relative uk-position-center">
          <ion-spinner name="lines"></ion-spinner>
        </div>
      </template>
    </suspense>
    <ReloadPrompt/>
  </ion-app>
</template>

<style>
/*----- import uikit -----*/
@import "../node_modules/uikit/dist/css/uikit.css";
</style>
